module.exports = __webpack_public_path__ + "img/icon-startup-light.ac22d728.svg";